import compact from "lodash/compact";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import pick from "lodash/pick";
import {
  FIELD_CUSTOM_FIELDS_KEY,
  FIELD_DESCRIPTION_KEY,
  FIELD_NAME_KEY,
  FIELD_SKILLS_KEY
} from "PFApp/constants/activity_form/activity_form_field_keys";
import { ActivityCustomField, CustomValue } from "PFCore/types";
import { FieldValues } from "react-hook-form";

import { SkillsFrameworksSuggestionsParams } from "./use_form_skills_frameworks_suggestions.types";

const MAX_RECOMMENDATION_TERM_LENGTH = 255;

const getSkillsNames = (skills: CustomValue[]) => skills.map((skill) => skill.text.trim()).join(" ");
const getRecommendationTerm = (parts: string[]) =>
  compact(parts).join(" ").slice(0, MAX_RECOMMENDATION_TERM_LENGTH);

const parseCustomFieldsForAPIPayload = (values: ActivityCustomField): ActivityCustomField[] =>
  Object.keys(values)
    .filter((name) => name !== "skills" && !isEmpty(values[name]))
    .map((name) => ({
      type: { name },
      values: values[name].map((value) => pick(value, ["id"]))
    })) as ActivityCustomField[];

export const getSuggestionsParams = (values: FieldValues): SkillsFrameworksSuggestionsParams => {
  const name: string = (get(values, FIELD_NAME_KEY) || "").trim();
  const description: string = (get(values, FIELD_DESCRIPTION_KEY) || "").trim();
  const skillsNames: string = getSkillsNames(get(values, FIELD_SKILLS_KEY) || []);

  return {
    recommendationTerm: getRecommendationTerm([name, description, skillsNames]),
    customFields: parseCustomFieldsForAPIPayload(values[FIELD_CUSTOM_FIELDS_KEY] || [])
  };
};
